import { MetadataIcon } from '#app/components/icons'

export default {
	name: 'Countersign',
	slug: 'countersign',
	description: 'Complete a two way verified attestation',
	isCountersign: true,
	version: '1.0.0',
	icon: <MetadataIcon />,
	fields: [
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Description of the countersign',
		},
		{
			name: 'Original Metadata CID',
			slug: 'originalMetadataIPFSCID',
			required: true,
			readOnly: true,
			hidden: true,
			type: 'text',
			placeholder: 'The IPFS CID of the original metadata',
		},
		{
			name: 'Original Attestation CID',
			slug: 'originalAttestationIPFSCID',
			required: true,
			readOnly: true,
			hidden: true,
			type: 'text',
			placeholder: 'The IPFS CID of the original attestation',
		},
	],
	info: 'https://atomicform.faq',
}
